import { Navbar } from "@/components/activehuman/Navbar";
import { Hero } from "@/components/activehuman/Hero";
import { Benefits } from "@/components/activehuman/Benefits";
import { Features } from "@/components/activehuman/Features";
import { Story } from "@/components/activehuman/Story";
import { About } from "@/components/activehuman/About";
import { Footer } from "@/components/activehuman/Footer";

const Landing = () => {
  const onNotifyClick = () => {
    const el = document.getElementById("notify");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      const input = el.querySelector('input[type="email"]');
      if (input) setTimeout(() => input.focus(), 700);
    }
  };

  return (
    <div data-testid="landing-page" className="bg-[#FDFBF7] text-[#1A362D]">
      <Navbar onNotifyClick={onNotifyClick} />
      <main>
        <Hero />
        <Benefits />
        <Features />
        <Story />
        <About />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
